module.exports = __webpack_public_path__ + "static/img/very-satisfied-01.0e95a8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/very-satisfied-01.jpg
// module id = 298
// module chunks = 1